export default "__VITE_ASSET__VCag$PW1__"